<script lang="ts" setup>
import AUApi from "@/api";
import {
  getKZColumn,
  getKZValue,
  getValue,
  getEinheitFromColumn,
  getKZTitle,
} from "@/DataHelper";
import { AxiosResponse } from "axios";
import { ref, onMounted } from "vue";
import { getSiteData } from "@/NavigationHelper";
import MdRelativeDestChart from "@/components/MD/relativeDestChart.vue";
import baseList from "@/components/baseList.vue";
declare interface ChartListItems extends ListItems {
  destination: number;
  value: number;
  chartColumns: any;
  chartData: any;
}
const props = defineProps<{
  druckItems?: ALLDruck[];
  exportItems?: AbfrageItems[];
  persoenlich?: boolean;
  formular?: ALLFrame;
  fixHeight?: number;
  print?: boolean;
  query?: string;
  showHeader?: boolean;
  showAvatart?: boolean;
  showAvatarLeft?: boolean;
  showSpeedDial?: boolean;
  showClose?: boolean;
  showFilter?: boolean;
}>();
const emit = defineEmits<{
  (e: "back", payload?: any): void;
  (e: "vector", vec: number[]): void;
}>();
let zeitbereich: APIZeitbereich = AUApi.Current.zeitbereich;

let queryEdit = ref<string>("");
const siteData = getSiteData();
let useVecStamm!: boolean;
let vecStamm: any[] = [];
let queryChart = ref<string>("");
let chartDataLoading = ref<boolean>(false);
let chartDataLoading1: boolean = false;
let chartType!: string | undefined;

let chartData: QueryResponse;
let chartColumns: DataColumn[] = [];
let unit = ref<string>("");
let textValue = ref<string>("");
let textDest = ref<string>("");
let textDiff = ref<string>("");
function sendBack(param?: any): any {
  emit("back", param);
}
function sendVector(vec: number[]) {
  emit("vector", vec);
}
let diagramCol: DataColumn | undefined;
let diagramCol1: DataColumn;
function baseListDataLoaded(data?: QueryResponse) {
  if (data && data.columns) {
    diagramCol = data.columns?.find((col) => col.meta.kz === "diagramm");
    if (diagramCol) {
      chartDataLoading.value = true;
    }
    if (diagramCol && diagramCol.meta) {
      if (diagramCol.meta.subAbf) {
        const metasubAbf = diagramCol.meta.subAbf[0];
        queryChart.value = metasubAbf.kennung ?? "";
      }
      if (diagramCol.meta.subGra) {
        const metasubGra = diagramCol.meta.subGra[0];
        chartType = metasubGra.kennung ?? "";
      }
    }
    if (chartType) {
      if (chartType === "Web_Pie") {
        chartType = "Pie";
      }
    }
    let setztVector = "";
    if (useVecStamm) {
      setztVector = "1";
    }
    if (!queryChart.value) {
      chartDataLoading.value = false;
    } else {
      let formAic = 0;
      if (props.formular) {
        formAic = props.formular.aic;
      }
      AUApi.Current.getQuery(
        queryChart.value,
        (d: any) => chartDataLoaded(d, false),
        null,
        zeitbereich,
        0,
        false,
        false,
        setztVector,
        formAic,
        vecStamm
      );
    }
  }
}

let aicCol: DataColumn;
function chartDataLoaded(
  data: AxiosResponse<QueryResponse>,
  diagramm1: boolean
) {
  chartData = data.data;
  chartColumns = chartData?.columns;
  if (diagramm1) {
    chartDataLoading1 = false;
  } else {
    chartDataLoading.value = false;
  }
  aicCol = getKZColumn("aic", chartData?.columns);
}

function addChartData(item: ChartListItems) {
  if (!aicCol) {
    return "--";
  }
  const row = chartData?.data.find((d: any) => {
    const dval = d[aicCol?.name ?? ""];
    return item.aic === dval?.aic;
  });
  if (row) {
    if (!chartType || chartType === "StackedBar") {
      item.value = getKZValue(row, "value", chartData?.columns);
      textValue = getKZTitle(row, "textValue", chartData?.columns);
      item.destination = getKZValue(row, "dest", chartData?.columns);
      textDest = getKZTitle(row, "textDest", chartData?.columns);
      textDiff = getKZTitle(row, "textDiff", chartData?.columns);
      const col = getKZColumn("dest", chartData?.columns);
      unit = getEinheitFromColumn(col).bezeichnung;
    } else {
      item.chartData = chartData;
      item.chartColumns = chartColumns;
    }
  }
}
function checkDetailFormColumn(col: DataColumn): boolean {
  // überspringen für die diagramcolumn
  if (col === diagramCol) {
    return true;
  }
  return false;
}
</script>
<template>
  <baseList
    :zeitbereich="zeitbereich"
    :query="props.query"
    :queryEdit="queryEdit"
    :siteData="siteData"
    :showClose="props.showClose"
    @back="sendBack"
    :fixHeight="props.fixHeight"
    :druckItems="props.druckItems"
    :exportItems="props.exportItems"
    :print="props.print"
    :showFilter="props.showFilter"
    :showSpeedDial="props.showSpeedDial"
    :showAvatarLeft="props.showAvatarLeft"
    :checkDetailFormColumnCallback="checkDetailFormColumn"
    @dataloaded="baseListDataLoaded"
    @vector="sendVector"
    :showHeader="props.showHeader"
    :pers="props.persoenlich"
    :formular="props.formular"
  >
    <template v-slot:itemAppend="{ item }">
      <v-progress-linear v-if="chartDataLoading" indeterminate />
      {{ addChartData(item as ChartListItems) }}
      <MdRelativeDestChart
        v-if="!chartDataLoading && queryChart && diagramCol"
        :destination="(<ChartListItems>item).destination"
        :value="(<ChartListItems>item).value"
        :unit="unit"
        :textDest="textDest"
        :textValue="textValue"
        :textDiff="textDiff"
      />
    </template>
  </baseList>
</template>
